export default __webpack_public_path__ + "static/media/wealth_map_head_02.90d4819d.png";